"use client";
import { ReactNode, useEffect, useRef } from "react";
import useElementEvents from "@/hooks/eventing/useElementEvents";
import { ElementViewed } from "@/hooks/eventing/types/redventures.usertracking.v3.ElementViewed";
import { useInView } from "react-intersection-observer";
import { ElementType } from "@/constants/tagular/main";
import { hyphenateForTagular } from "@/utils/tagular/helpers";

export interface HomepageStatsAndSocialProofProps {
  children?: ReactNode;
  htmlId?: string;
  location?: string;
}

// Test variant component with element viewed tracking
function StatsAndSocialProofTestVariant({
  children,
  htmlId,
  location,
}: {
  children?: ReactNode;
  htmlId?: string;
  location?: string;
}) {
  const webElement: ElementViewed["webElement"] = {
    elementType: ElementType.Component,
    htmlId: htmlId,
    location: location,
    text: "Stats and Social Proof Test Variant",
    position: "1",
    name: hyphenateForTagular("stats-social-proof-test-variant"),
  };

  const { elementViewed } = useElementEvents({ webElement });
  const { inView, ref } = useInView();
  const viewedRef = useRef(false);

  useEffect(() => {
    if (inView && !viewedRef.current) {
      elementViewed();
      viewedRef.current = true;
    }

    // Reset when element goes out of view
    if (!inView) {
      viewedRef.current = false;
    }
  }, [inView, elementViewed]);

  return <div ref={ref}>{children}</div>;
}

export default function HomepageStatsAndSocialProof({
  children,
  ...props
}: HomepageStatsAndSocialProofProps) {
  return (
    <StatsAndSocialProofTestVariant>{children}</StatsAndSocialProofTestVariant>
  );
}
